import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class BordroAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetBordroRapor";
        super(baseUrl);
    }


    geExportPdfListe(sqId: string, kadroTuruId: number) {

        //var request = new BordroRaporRequest(sqId, kadroTuruId);
        let enRequest: IBordroRequest = {
            sqId: sqId,
            kadroTuruId: kadroTuruId,
        };
        return this.post("", enRequest, true);
    }

}
export default new BordroAPI();
class BordroRaporRequest {
    public sqId: string;
    public kadroTuruId: number;

    constructor(sqId: string, kadroTuruId: number) {

        this.sqId = sqId;
        this.kadroTuruId = kadroTuruId;

    }
}
interface IBordroRequest {
    sqId: string;
    kadroTuruId: number;
}
export { BordroRaporRequest };